import axios from 'axios';

class InventoryGateway {
  constructor({ config }) {
    this.config = {};
    this.config.baseURL = config.InventoryAPI.url;
    this.client = axios.create({
      baseURL: this.config.baseURL,
      timeout: 100000,
    });
    this.cache = {
      expires: 0,
      data: [],
      isExpired: () => Date.now() > this.cache.expires,
      set: (data, expiry) => {
        this.cache.expires = Date.now() + expiry;
        this.cache.data = data;
      },
      get: () => this.cache.data,
    };
  }

  async locate(conversation) {
    try {

      const response = await this.client.post('/inventory/agent/locator', {
        input: {prompt: conversation},
      },);

      let locatedVehicles = this.parse(response.data);

      if (locatedVehicles && locatedVehicles.length > 0 && locatedVehicles[0].length > 8) {
        locatedVehicles[0] = locatedVehicles[0].slice(0, 8);
      }
      
      return locatedVehicles;
    } catch (error) {
      console.error('Error transmitting messages:', error);
      throw error;
    }
  }

  parse = (queryResult) => {  

    let inventory = []; 
    
    queryResult.documents.map((queryDocuments) => {
      inventory = [...inventory, queryDocuments.map((doc) => {
        const [
          DealerID,
          DealerName,
          VehicleCondition,
          ChromeStyleID,
          VIN,
          Year,
          Make,
          Model,
          Trim,
          BodyType,
          Transmission,
          Engine,
          FuelType,
          DriveTrain,
          ListPrice,
          SellingPrice,
          PhotoURL,
          VideoURL,
          CityMPG,
          HighwayMPG,
          StandardEquipment,
          OptionalEquipment,
          VDP,
          VehicleStatus,
        ] = doc.split('|');

        return {
          DealerID,
          DealerName,
          VehicleCondition,
          ChromeStyleID,
          VIN,
          Year,
          Make,
          Model,
          Trim,
          BodyType,
          Transmission,
          Engine,
          FuelType: Engine === 'Electric' ? null : FuelType,
          DriveTrain,
          ListPrice,
          SellingPrice,
          PhotoURL,
          VideoURL,
          CityMPG,
          HighwayMPG,
          StandardEquipment: StandardEquipment ? StandardEquipment.split(';').sort(() => 0.5 - Math.random()).slice(0, 10).sort() : [],
          OptionalEquipment: OptionalEquipment ? OptionalEquipment.split(';').sort(() => 0.5 - Math.random()).slice(0, 10).sort() : [],
          VDP,
          VehicleStatus
        };
      })];

        return inventory
    });

    inventory = this.prioritizeInventoryWithMedia(inventory);

    return inventory;
  };

  prioritizeInventoryWithMedia = (inventory) => {
    let inventoryWithPhotosAndVideos = inventory[0].filter((vehicle) => vehicle.PhotoURL && vehicle.VideoURL);
    let inventoryWithPhotos = inventory[0].filter((vehicle) => vehicle.PhotoURL && !vehicle.VideoURL);
    let inventoryWithVideos = inventory[0].filter((vehicle) => vehicle.VideoURL && !vehicle.PhotoURL);
    let inventoryWithoutMedia = inventory[0].filter((vehicle) => !vehicle.PhotoURL && !vehicle.VideoURL);

    inventory[0] = [...inventoryWithPhotosAndVideos, ...inventoryWithPhotos, ...inventoryWithVideos, ...inventoryWithoutMedia];

    return inventory;
  };

  async vehicleDetails(vin) {
    try {
      const response = await this.client.get(`/inventory/vehicle/${vin}`);
      return response.data;
    } catch (error) {
      console.error('Error getting vehicle details:', error);
      throw error;
    }
  }

  async intelligentPitch(vin) {
    try {
      const response = await this.client.post(`/inventory/agent/pitch/`, {
          input: {
            vin: vin
          },
      },);
      
      return response.data;
    } catch (error) {
      console.error('Error getting intelligent pitch:', error);
      
      throw error;
    }
  }
}

export default InventoryGateway;